import { CHANGE_AD_UNIT_PATH } from './constants'

export function changeAdUnitPaths (adUnitPaths) {
  return {
    type: CHANGE_AD_UNIT_PATH,
    payload: adUnitPaths,
  }
}



// WEBPACK FOOTER //
// ./src/services/ads/actions.js